import { createContext, useContext } from 'react';
import type { AvatarSize } from '../hooks';

// We need a default `md` size from our theme for standalone avatars, but the group needs children without their own size.
// Without this context, the group size did not apply to children because the Avatar always passed the default `md`,
// overriding Ant Design group size propagation.

const AvatarGroupSizeContext = createContext<AvatarSize | number | undefined>(undefined);

export const AvatarGroupSizeProvider = AvatarGroupSizeContext.Provider;

export const useAvatarGroupSize = () => useContext(AvatarGroupSizeContext);
